module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAYAAADphp8SAAAAAXNSR0IArs4c6QAAAVxJREFUOE/N0r9LQlEYxvHve6+CF65Q0BRE1Fqbk7Qc0b0Wo6EhiIogwaCtNRpqCGqoaI7aG1WurpX04y9oiChcDAmj1DeMG4ggmi2d+X0+POc9R6LRqBMKhVKNRmOUPo5lWQ+qeiDGmA1gtw+jNZJuQpvA1h+gT2BdmoAxZg7YAUZ+Cd7Ytr2Qy+XuJR6Pj5fL5edwOPwhItuqugq4XcAXIJ3P58+NMUOqOiaxWGxfVWdFZNrzvKtEIhGu1WoXqjolIlYb+A4cAxuO49jVanUeOFTVvR8o5QeKgUAgns1mX5tN6/X6NTAIKHBXqVSmisVi1RgzAXjAUDOnqjvt0LcnIiee5y37+5sJBoOXmUzmKZlM2qVS6RaYbG3aEfKH3lR1qVAonPngEbAIBNr31w36bg08Aw4w0OkBeoF6+g3/FDLGrAEHPd2hw5CIrEgkEgm6rjsvIsN9Yo/A6RezcKlBVBdlFQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/youjian.png
// module id = kLhr
// module chunks = 1